
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import {
  FaHome, FaTags, FaShoppingCart,
  FaUsers, FaChevronDown, FaChevronRight,
  FaSignOutAlt, FaEnvelope, FaBox, FaUserMinus
} from 'react-icons/fa';
import io from 'socket.io-client';
import Logo from "../../../public/AfricFreshLogo-01.svg";
import { TbDiscountOff } from "react-icons/tb";
import { FaTruckFast } from "react-icons/fa6";
import { GiPayMoney } from "react-icons/gi";
import { TbTruckDelivery } from "react-icons/tb";
import { AiFillProduct } from "react-icons/ai";

const Sidebar = ({ isOpen }) => {
  const location = useLocation();
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [totalCategories, setTotalCategories] = useState(0);
  const [unreadMessages, setUnreadMessages] = useState(
    JSON.parse(localStorage.getItem('unreadMessages')) || 0
  );
  const [unreadOrders, setUnreadOrders] = useState(
    JSON.parse(localStorage.getItem('unreadOrders')) || 0
  );

  const [unreadDelectedAccounts, setDelectedAccounts] = useState(
    JSON.parse(localStorage.getItem('unreaddeletedUser')) || 0
  );
  const socket = useRef(null);

  const sidebarItems = [
    // { icon: <FaHome />, label: 'Dashboard', path: '/admin/dashboard' },
    { icon: <FaUsers />, label: 'Customers', path: '/admin/customerlist' },
    { icon: <FaTruckFast />, label: 'Drivers', path: '/admin/drivermanagement' },
    { icon: <GiPayMoney />, label: 'Subscription', path: '/admin/subscription' },
    { icon: <AiFillProduct />, label: 'Subscription-Product', path: '/admin/subscription-product' },
    {
      icon: <FaUserMinus />,
      label: 'Deleted Accounts',
      path: '/admin/deleted-account',
      badge: unreadDelectedAccounts,
    },
    { icon: <FaTags />, label: 'Blogs', path: '/admin/blog' },
    {
      icon: <FaShoppingCart />,
      label: 'Orders',
      path: '/admin/orders',
      badge: unreadOrders,
    },
    {
      icon: <TbTruckDelivery />,
      label: 'Deliveries',
      path: '/admin/delivery-history',
    },
    {
      icon: <FaEnvelope />,
      label: 'Messages',
      path: '/admin/adminmessages',
      badge: unreadMessages,
    },
    { icon: <TbDiscountOff />, label: 'Discount', path: '/admin/discount' },
    { icon: <FaBox />, label: 'Products', path: '/admin/products' },
   
  ];


  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    const fetchCategories = async () => {
      try {
        
        const response = await axios.get("https://afric-fresh-backend.onrender.com/admin/categories" ,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }});
        setCategories(response.data.categories);
        setTotalCategories(response.data.categories.length);
      } catch (error) {
        console.error('Failed to fetch categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleLogout = () => {
    // Remove admin session from localStorage
    localStorage.removeItem("adminToken");
    localStorage.removeItem("admindetails");

    // Redirect to admin signin page
    window.location.href = "/admin/signin";
  };

  useEffect(() => {
    socket.current = io("https://afric-fresh-backend.onrender.com", {
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity,
    });

    const fetchInitialCounts = async () => {
      try {
        const token = localStorage.getItem("adminToken");

        const [messagesResponse, ordersResponse, deletedAccountsResponse] = await Promise.all([
          
          axios.get("https://afric-fresh-backend.onrender.com/api/messages/unread" ,
            {
              headers: {
                Authorization: `Bearer ${token}`
              }}),
          axios.get(
            "https://afric-fresh-backend.onrender.com/order/unread-order"
            // "http://localhost:3005/order/unread-order"
            
            ,{
              headers: {
                Authorization: `Bearer ${token}`
              }}),
          axios.get(
            "https://afric-fresh-backend.onrender.com/admin/deleted-accounts/unviewed"
            // "http://localhost:3005/admin/deleted-accounts/unviewed"
            
            ,{
              headers: {
                Authorization: `Bearer ${token}`
              }})
        ]);
        const unreadMessagesCount = messagesResponse.data.length;
        const unreadOrdersCount = ordersResponse.data.count;
        const unreadDeletedAccountsCount = deletedAccountsResponse.data.count;

        setUnreadMessages(unreadMessagesCount);
        setUnreadOrders(unreadOrdersCount);
        setDelectedAccounts(unreadDeletedAccountsCount);

        // Persist counts in localStorage
        localStorage.setItem('unreadMessages', JSON.stringify(unreadMessagesCount));
        localStorage.setItem('unreadOrders', JSON.stringify(unreadOrdersCount));
        localStorage.setItem('unreaddeletedUser', JSON.stringify(unreadDeletedAccountsCount));
      } catch (error) {
        console.error('Error fetching initial counts:', error);
      }
    };

    fetchInitialCounts();

    // Message Socket Events
    socket.current.on('newMessage', () => {
      setUnreadMessages((prev) => {
        const newCount = prev + 1;
        localStorage.setItem('unreadMessages', JSON.stringify(newCount));
        return newCount;
      });
    });

    socket.current.on('messageRead', () => {
      setUnreadMessages((prev) => {
        const newCount = Math.max(0, prev - 1);
        localStorage.setItem('unreadMessages', JSON.stringify(newCount));
        return newCount;
      });
    });

    // Order Socket Events
    socket.current.on('newOrder', () => {
      setUnreadOrders((prev) => {
        const newCount = prev + 1;
        localStorage.setItem('unreadOrders', JSON.stringify(newCount));
        return newCount;
      });
    });

      // Deleted Account Socket Events
      socket.current.on('deletedUser', () => {
        setDelectedAccounts((prev) => {
          const newCount = prev + 1;
          localStorage.setItem('unreaddeletedUser', JSON.stringify(newCount));
          return newCount;
        });
      });
      

    // Clean up socket events
    return () => {
      if (socket.current) {
        ['newMessage', 'messageRead', 'newOrder', 'ordersRead', 'deletedUser', 'deletedAccountRead']
          .forEach((event) => socket.current.off(event));
        socket.current.disconnect();
      }
    };
  }, []);

  const toggleCategories = () => {
    setIsCategoriesOpen(!isCategoriesOpen);
  };

  const handleOrdersClick = async () => {
    if (unreadOrders > 0) {
      try {
        const token = localStorage.getItem("adminToken");

        await axios.put("https://afric-fresh-backend.onrender.com/order/mark-orders-read" ,{
          headers: {
            Authorization: `Bearer ${token}`
          }});
        setUnreadOrders(0);
        localStorage.setItem('unreadOrders', JSON.stringify(0));
      } catch (error) {
        console.error('Error marking orders as read:', error);
      }
    }
  };

  const handleDeletedAccountsClick = async () => {
    if (unreadDelectedAccounts > 0) {
      try {
        const token = localStorage.getItem("adminToken");

        await axios.put(
          "https://afric-fresh-backend.onrender.com/admin/deleted-accounts/mark-viewed"
          // "http://localhost:3005/admin/deleted-accounts/mark-viewed"

          ,{
            headers: {
              Authorization: `Bearer ${token}`
            }});
        setDelectedAccounts(0);
        localStorage.setItem('unreaddeletedUser', JSON.stringify(0));
      } catch (error) {
        console.error('Error marking deleted accounts as viewed:', error);
      }
    }
  };

  return (
    <div
      className={`
        fixed left-0 top-0 h-full bg-white shadow-lg 
        transition-all duration-300 z-50
        ${isOpen ? 'w-64' : 'w-20'}
        overflow-hidden
      `}
    >
      <div className="p-2 flex items-center justify-between border-b">
        {isOpen && (
          <h2 className="text-xl font-bold text-blue-600">
            <img src={Logo} className="w-32 h-10" alt="Logo" />
          </h2>
        )}
      </div>

      <nav className="mt-1">
        {sidebarItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`
              flex items-center p-3 hover:bg-blue-50 
              ${location.pathname === item.path ? 'bg-blue-100 text-blue-600' : ''}
            `}
            onClick={() => {
              if (item.path === '/admin/orders') {
                handleOrdersClick();
              }
              if (item.path === '/admin/deleted-account') {
                handleDeletedAccountsClick();
              }
            }}
            
          >
            <span className="flex items-center">
              {item.icon}
              {item.badge > 0 && (
                <span className="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs transform translate-x-3">
                  {item.badge}
                </span>
              )}
            </span>
            {isOpen && <span className="ml-4">{item.label}</span>}
          </Link>
        ))}

        <div
          onClick={toggleCategories}
          className={`
            flex items-center p-2 hover:bg-blue-50 cursor-pointer
            ${isCategoriesOpen ? 'bg-blue-100 text-blue-600' : ''}
          `}
        >
          {isOpen && (
            <div className="flex justify-between items-center w-full">
              <div className="flex items-center">
                <span className="mr-2">Categories</span>
                <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full">
                  {totalCategories}
                </span>
              </div>
              {isCategoriesOpen ? <FaChevronDown /> : <FaChevronRight />}
            </div>
          )}
        </div>

        {isOpen && isCategoriesOpen && (
          <div className="bg-gray-100 py-2 pb-20 max-h-52 overflow-y-auto scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-blue-500">
            {categories.map((category, index) => (
              <Link
                key={index}
                to={`/admin/category/${category.name.toLowerCase().replace(/\s+/g, '')}`}
                className={`
                  flex items-center justify-between p-2 pl-12 hover:bg-blue-50
                  ${location.pathname === `/admin/category/${category.name.toLowerCase().replace(/\s+/g, '')}` ? 'bg-blue-100 text-blue-600' : ''}
                `}
              >
                <span>{category.name}</span>
                <span className="text-xs text-gray-500 mr-4">
                  ({category.productCount})
                </span>
              </Link>
            ))}
          </div>
        )}

        <div
          onClick={handleLogout}
          className="absolute bottom-0 left-0 right-0 p-4 border-t cursor-pointer hover:bg-red-50"
        >
          <div className="flex items-center">
            <FaSignOutAlt className="text-xl mr-4" />
            {isOpen && <span>Logout</span>}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
